import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {Router, RouterOutlet} from '@angular/router';
import {FetchUser, Logout} from 'src/app/shared/state/session-state.actions';
import {SessionState} from 'src/app/shared/state/session-state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly actions = inject(Actions);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  constructor() {
    this.actions
      .pipe(
        ofActionDispatched(Logout),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.router.navigate(['/auth/login']));

    this.loadAccount();
  }

  /**
   * Try and fetch the account object into the state.  This will either succeed and populate
   * the state with the account object, updating all query subscriptions, or it will fail
   * and do nothing.
   */
  private loadAccount(): void {
    if (this.store.selectSnapshot(SessionState.isAuthenticated)) {
      this.store
        .dispatch(FetchUser)
        .subscribe({error: () => console.log('Not logged in on initial account load')});
    }
  }
}
